window.tasksModule.controller 'OABDetailsController', ($location, $sce, $scope, $state, $stateParams, $log, AuthService, TasksService) ->
  $log = $log.getInstance('OABDetailsController', true, false, true)
  $scope.environment = AuthService.getEnvironment()
  $log.log 'OAB details controller loaded.'

  $scope.getContentUrl = ->
    if $scope.environment is 'production'
      $sce.trustAsResourceUrl 'https://content.patientfusion.com/oab/oab_patient_guide_combined.pdf'
    else
      $sce.trustAsResourceUrl String($location.protocol() + '://content.patientfusion.com/oab/oab_patient_guide_combined.pdf')